import { Reducer } from 'redux'
import { createReducer } from 'reduxsauce'
import { IFilter, IReportState, ReportTypes } from './types'
import {
    failure, IActionType,/*, success, failure, request, IPaginator, ISearch */
    request,
    success
} from '../root.types'
import moment from 'moment'
import { ActiveSearchResponse } from '../../application/models/report/active.search.response'
import { ActiveSearchSummary } from '../../application/models/report/active.search.summary'
import { Report } from '../../application/models/report/report'

const INITIAL_STATE: IReportState = {
    report: {
        data: new Report(),
        loading: false,
        success: false,
        error: false,
    },
    activeSearchResponse: {
        data: new ActiveSearchResponse(),
        loading: false,
        success: false,
        error: false,
    },
    activeSearchSummary: {
        data: new ActiveSearchSummary(),

        loading: false,
        success: false,
        error: false,
    },
    filter: {
        primaryDate: moment().toDate().toISOString(),
        secondaryDate: moment().toDate().toISOString(),
    }
}

export const loadReportRequest = (state: IReportState = INITIAL_STATE,
    action: IActionType<{ filter: IFilter }>) => {
    const { filter } = action.payload
    return { ...state, report: request({ ...state.report, filter }) }
}
export const loadReportSuccess = (state: IReportState = INITIAL_STATE,
    action: IActionType<{ data: Report }>) => {
    const { data } = action.payload
    return { ...state, report: success({ ...state.report,  data }) }
}
export const loadReportFailure = (state: IReportState = INITIAL_STATE) => {
    return { ...state, report: failure(state.report) }
}

export const loadActiveSearchSummaryRequest = (state: IReportState = INITIAL_STATE,
    action: IActionType<{ filter: IFilter }>) => {
    const { filter } = action.payload
    return {
        ...state,filter ,
        activeSearchSummary:
            request({ ...state.activeSearchSummary, })
    }
}
export const loadActiveSearchSummarySuccess = (state: IReportState = INITIAL_STATE,
    action: IActionType<{ data: ActiveSearchSummary }>) => {
    const { data } = action.payload
    return {
        ...state,
        activeSearchSummary: success({ ...state.activeSearchSummary, data })
    }
}
export const loadActiveSearchSummaryFailure = (state: IReportState = INITIAL_STATE) => {
    return { ...state, activeSearchSummary: failure(state.activeSearchSummary) }
}
export const loadActiveSearchResponseRequest = (state: IReportState = INITIAL_STATE,
    action: IActionType<{ filter: IFilter }>) => {
    const { filter } = action.payload
    return {
        ...state,filter ,
        activeSearchResponse: request({ ...state.activeSearchResponse, })
    }
}
export const loadActiveSearchResponseSuccess = (state: IReportState = INITIAL_STATE,
    action: IActionType<{ data: ActiveSearchResponse }>) => {
    const { data } = action.payload
    return {
        ...state,
        activeSearchResponse: success({ ...state.activeSearchResponse,  data })
    }
}
export const loadActiveSearchResponseFailure = (state: IReportState = INITIAL_STATE) => {
    return { ...state, activeSearchResponse: failure(state.activeSearchResponse) }
}
const reducer: Reducer<IReportState> = createReducer<IReportState>(INITIAL_STATE, {
    [ReportTypes.LOAD_REPORT_REQUEST]: loadReportRequest,
    [ReportTypes.LOAD_REPORT_SUCCESS]: loadReportSuccess,
    [ReportTypes.LOAD_REPORT_FAILURE]: loadReportFailure,

    [ReportTypes.LOAD_ACTIVE_SEARCH_SUMMARY_REQUEST]: loadActiveSearchSummaryRequest,
    [ReportTypes.LOAD_ACTIVE_SEARCH_SUMMARY_SUCCESS]: loadActiveSearchSummarySuccess,
    [ReportTypes.LOAD_ACTIVE_SEARCH_SUMMARY_FAILURE]: loadActiveSearchSummaryFailure,

    [ReportTypes.LOAD_ACTIVE_SEARCH_RESPONSE_REQUEST]: loadActiveSearchResponseRequest,
    [ReportTypes.LOAD_ACTIVE_SEARCH_RESPONSE_SUCCESS]: loadActiveSearchResponseSuccess,
    [ReportTypes.LOAD_ACTIVE_SEARCH_RESPONSE_FAILURE]: loadActiveSearchResponseFailure,
})
export default reducer    